import { SxProps, Theme } from "@mui/material";

export function listRequestsWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1, 
        width: "100%", 
        borderRadius: "20px", 
        my: "24px", 
        // height: "calc(100vh - (84px * 1) - 2px - 48px)", 
        // maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)"
    };
}

export function listRequestsTitle(theme: Theme): SxProps<Theme> {
    return {
        margin: 0,
        paddingTop: "0.3em",
        paddingBottom: '0.3rem',
        '&:first-letter': {
            textTransform: 'uppercase',
        },
    };
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec",
    };
}

export function infoWrapper(theme: Theme): SxProps<Theme> {
    return {
        border: "2px solid lightgray", 
        backgroundColor: "#f1f1f1",
        padding: "0px", 
        paddingBottom: "16px",
        borderRadius: "10px",
        margin: "0",
        marginBottom: "16px",
        maxWidth: "100%",
    };
}

// export function textCentered(theme: Theme): SxProps<Theme> {
//     return {
//         display: 'flex', 
//         alignItems: 'center', 
//         height: '100%'
//     };
// }